
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, Tooltip, LinearProgress, Chip, Modal } from '@mui/material';
import { TrendingDown, TrendingUp } from 'lucide-react'
import { DatePicker, message } from 'antd';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { HelpOutline } from '@mui/icons-material';
import { OutlierGraph, SkewnessKurtosisGraph } from './Graphs';
import dayjs from "dayjs";

const LableChips = (value) =>{      
      return(value&&<Chip
                label={value?.charAt(0).toUpperCase() + value?.slice(1)}
                sx={{
                  bgcolor: `${
                    value.toLocaleString()=='Numeric'?'rgba(228,252,236)'
                    :value.toLocaleString()=='Categorical'?'rgba(231,237,255)'
                    :value.toLocaleString()=='Date Time'?'rgba(254,234,234)':'rgba(255,247,231)'}`,
                  // px: 0.2,

                  color:`${
                    value. toLocaleString()=='Numeric'?'#166534'
                    :value.toLocaleString()=='Categorical'?'#2e4eb5'
                    :value.toLocaleString()=='Date Time'?'#9d2323':'#f59002'}`,
                  // py: 0.10,
                  borderRadius: '4px',
                  fontFamily: 'monospace',
                  fontSize: '0.875rem',
                }}
                >
                </Chip>
      )
  }

const RenderTableHeader = (key, descripion) =>{

  return(
      <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {/* <Tooltip title={descripion} placement="top">
          <Typography> */}
            {key}
          {/* </Typography>
        </Tooltip> */}
        <Tooltip title={descripion} placement="top">
          <HelpOutline fontSize="small" style={{fontSize:'12px'}}/>
        </Tooltip>
      </div>
    )

}




export const DataQuality = (props) => {
    const [ColumnData, setColumnData] = useState(null)
    const [ShowPopUpGraph, setShowPopUpGraph] = useState(false)
    const [GraphType, setGraphType] = useState(null)
    const [SelectedColumn, setSelectedColumn] = useState(null)
    const [AllColsSkewKurtGraphData, setAllColsSkewKurtGraphData ] = useState(null)
    const [SkewKurtGraphData, setSkewKurtGraphData] = useState(null)
    const [loadingGraph, setloadingGraph] = useState(true)
    const [OutliersGraphData, setOutliersGraphData] = useState(null)
    const [DisableDates, setDisableDates] = useState(null)
    const [SelectedDate, setSelectedDate] = useState(null)
    const [DailyStats, setDailyStats] = useState()
    const [loading, setloading] = useState(false)
  
    const TableColumns = [
      {
        field: 'column',
        headerName: 'Column Name',
        minWidth: 250,
        editable: false,
        renderHeader: () => (
          RenderTableHeader('Column Name', 'This column shows the name of the column in the dataset.')
        )
      },
      {
        field: 'type',
        headerName: 'Type',
        minWidth: 160,
        editable: false,
        renderCell:(params) => <>{LableChips(params?.row?.type)}</>,
        renderHeader: () => (
          RenderTableHeader('Type', 'This column shows the data type of the column.')
        )    
      },
      {
      field: 'density',
      headerName: 'Completeness',
      minWidth: 250,
      editable: false,
      renderCell: (params) => {
        const density = params?.row?.density ?? 0;

        // Bar color logic
        let barColor = '#9d2323';
        if (density >= 90) barColor = '#166534';
        else if (density >= 70) barColor = '#f5b942';

        const tooltipText = (
          <Box sx={{ fontSize: '0.75rem' }}>
            <div>
              <strong>Total Rows:</strong> {(params?.row?.num_rows || 0) + (params?.row?.num_nulls || 0) }
            </div>
            <div>
              <strong>Rows with Data:</strong> {params?.row?.num_rows || 0}
            </div>
          </Box>
        );

        return (
          <Tooltip title={tooltipText} placement="top" arrow>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: '15px' }}>
              <LinearProgress
                variant="determinate"
                value={density}
                sx={{
                  width: 150,
                  height: 8,
                  borderRadius: 4,
                  bgcolor: 'rgba(121, 120, 119, 0.4)',
                  '& .MuiLinearProgress-bar': { bgcolor: barColor },
                }}
              />
              <Typography variant="body2">
                {density % 1 !== 0 ? parseFloat(density).toFixed(1) : density}%
              </Typography>
            </Box>
          </Tooltip>
        );
      },
      renderHeader: () =>
        RenderTableHeader(
          'Density',
          'This column shows the density of the column, indicating the percentage of non-null values.'
        ),
      },
      {
      field: 'null_pct',
      headerName: 'Nulls',
      minWidth: 150,
      renderCell: (params) => {
        const nullPct = params?.row?.null_pct ?? 0;       

        const tooltipText = (
          <Box sx={{ fontSize: '0.75rem' }}>
            <div>
              <strong>Total Rows:</strong> {(params?.row?.num_rows || 0) + (params?.row?.num_nulls || 0) }
            </div>
            <div>
              <strong>Nulls:</strong> {params?.row?.num_nulls ?? 0}
            </div>
          </Box>
        );

        return (
          <Tooltip title={tooltipText} placement="top" arrow>
            <Typography variant="body2" sx={{ pt: '15px' }}>
              {nullPct ? `${nullPct}%` : '-'}
            </Typography>
          </Tooltip>
        );
      },
      renderHeader: () =>
        RenderTableHeader(
          'Nulls',
          'This column shows the percentage of null values in the column.'
        ),
      },
      {
        field: 'outlier_pct',
        headerName: 'Outliers',
        minWidth: 150,
        renderCell: (params) => {        
          const outliersPct = Number(params?.row?.outliers_pct || params?.row?.outlier_pct) || 0;      
          
          const tooltipText = (
            <Box sx={{ fontSize: '0.75rem' }}>
              <div>
                <strong>Total Rows:</strong> {(Number(params?.row?.num_rows) || 0)}
              </div>
              <div>
                <strong>Outliers:</strong> {Number(params?.row?.num_outliers) || 0}
              </div>
            </Box>
          );

          return (
            <Tooltip title={tooltipText} placement="top" arrow>
              <Box 
                  sx={{ display: 'flex', gap: 1, paddingTop:'15px' }} 
                  style={{color:'var(--textPrimary)',cursor:'pointer'}} 
                  onClick={() => {
                    if (params?.row?.data_type && params?.row?.data_type === "daily"){
                      return ''
                    }
                    else{
                      setShowPopUpGraph(true)
                      setSelectedColumn(params?.row?.column)
                      setGraphType("outliers")
                      UpdateSelectedColumnGraphData(params?.row?.column)
                    }
                  }}
                >
                <Typography variant="body2" sx={{ pt: '15px' }}>
                  {outliersPct ? `${outliersPct}%` : '-'}
                </Typography>
              </Box>
            </Tooltip>
          );
        },
        renderHeader: () =>
          RenderTableHeader(
            'Outliers',
            'This column shows the number and percentage of outlier values that deviate significantly from the normal range.'
          ),
      },
      {
        field: 'quality',
        headerName: 'Quality',
        minWidth: 160,
        renderHeader: () => (
          RenderTableHeader('Quality', 'This column shows the data quality of the column based on its density. (Excellent, Good, Poor)')
        ),
      },
      {
        field: 'skewness',
        headerName: 'Skewness',
        minWidth: 160,
        renderCell:(params)=><Box 
                  sx={{ display: 'flex', gap: 1, paddingTop:'15px' }} 
                  style={{color:'var(--textPrimary)',cursor:'pointer'}} 
                  onClick={() => {
                    setShowPopUpGraph(true)
                    setGraphType("skewness_kurtosis")
                    setSelectedColumn(params?.row?.column)
                    UpdateSelectedColumnGraphData(params?.row?.column)
                  }}
                >
                          {params.row.skewness?params.row.skewness>=0?<TrendingUp size={20} color='green' />:<TrendingDown size={20} color='red' />:''}
                          <Typography variant="body2">
                            {params?.row?.skewness?params?.row?.skewness:'-'}
                          </Typography>
                        </Box>,
        renderHeader: () => (
          RenderTableHeader('Skewness', 'This column shows the skewness of the column, indicating the asymmetry of the distribution.')
        )
      },
      {
        field: 'kurtosis',
        headerName: 'Kurtosis',
        minWidth: 160,
        renderCell:(params)=><Box 
                    sx={{ display: 'flex', gap: 1, paddingTop:'15px' }} 
                    style={{color:'var(--textPrimary)',cursor:'pointer'}} 
                    onClick={() => {
                      setGraphType("skewness_kurtosis")
                      setShowPopUpGraph(true)
                      setSelectedColumn(params?.row?.column)
                      UpdateSelectedColumnGraphData(params?.row?.column)
                  }}
                        >
                          {params.row.kurtosis?params.row.kurtosis>=0?<TrendingUp size={20} color='green' />:<TrendingDown size={20} color='red' />:''}
                          <Typography variant="body2">
                            {params?.row?.kurtosis?params?.row?.kurtosis:'-'}
                          </Typography>
                        </Box>,
        renderHeader: () => (
          RenderTableHeader('Kurtosis', 'This column shows the kurtosis of the data, indicating the tailedness or peakedness of the distribution.')
        )
      }
    ];

    const GetSkewnessKurtosisGraphData = () =>{
       axios({
        method:'POST',
        url:'/api/histogramData',
        data:{
          "dataset_id":props?.SelectedProviderDataset?.value,
          "client_id":props?.SelectedProvider?.value
        }
      }).then((res)=>{
        setAllColsSkewKurtGraphData(res.data)  
        setloadingGraph(false) 
        if (SelectedColumn) {
            UpdateSelectedColumnGraphData(SelectedColumn)
        }    

      }).catch(err=>{
        console.log(err);
        // message.error(err?.response?.data?.error, 5)
      })
    }

    const getStatusData = () =>{
      axios({
        method:'POST',
        url:'/api/dataset_status',
        data:{
          "dataset_id":props?.SelectedProviderDataset?.value,
          "client_id":props?.SelectedProvider?.value
        }
      }).then((res)=>{
        const tempdata = res.data.map((item,index)=>{
          if (item.column === "date"){
            const MaxDate = item.max || ""
            const MinDate = item.min || ""
            if(MaxDate && MinDate){
              setDisableDates((MaxDate&&MinDate)?{"max_date":dayjs(MaxDate), "min_date":dayjs(MinDate)}:null)
              setSelectedDate(dayjs(MaxDate))
              GetDailyStats(MaxDate)
            }
          }
          return{
            "id":index,
            "label": item.column,
            "value": item.column,
            "quality":item.density==100?"Excellent":item.density>97?"Good":"Poor",
            "data_type":'history',
            ...item
          }
        })
        // props.setloader(false)
        props.setDatasetNumericColumns(tempdata.filter(item=>item?.type?.toLocaleString()=='Numeric'&&item?.column?.toLocaleString()!="security_id"))
        setColumnData(tempdata)
        props.setloadDashboard(true)

      }).catch(err=>{
        props.setloadDashboard(false)
        console.log(err);
        message.error(err?.response?.data?.error, 5)
      })
    }

    const UpdateSelectedColumnGraphData =(column) =>{      
      if (AllColsSkewKurtGraphData){
        setSkewKurtGraphData({
          "distribution" : AllColsSkewKurtGraphData.distribution.filter(item=> item.column == column),
          "histogram" : AllColsSkewKurtGraphData.histogram.filter(item=> item.column == column && item.type == 'normal' )
        })
        setOutliersGraphData({
          "column" : column,
          "bins" : AllColsSkewKurtGraphData.histogram.filter(item=> item.column == column && item.type == 'normal').map(item=> item.x),
          "counts" : AllColsSkewKurtGraphData.histogram.filter(item=> item.column == column && item.type == 'normal').map(item=> item.y),
          "outlier_bins" : AllColsSkewKurtGraphData.histogram.filter(item=> item.column == column && item.type == 'outlier').map(item=> item.x),
          "outliers" : AllColsSkewKurtGraphData.histogram.filter(item=> item.column == column && item.type == 'outlier').map(item=> item.y),
          "lower_bound" : ColumnData?.filter(item=> item.column == column)[0]['lower_bound'],
          "upper_bound" : ColumnData?.filter(item=> item.column == column)[0]['upper_bound']
        })
      }
    }

    const GetDailyStats = (date={SelectedDate}) =>{
      setloading(true)
      setDailyStats(null)
      axios({
        method:'POST',
        url:'/api/daily_stats',
        data:{
          "dataset_id":props?.SelectedProviderDataset?.value,
          "client_id":props?.SelectedProvider?.value,
          "date":date.toLocaleString()
        }
      }).then((res)=>{
        const tempdata = res.data.map((item,index)=>{
          return{
            "id":index,
            "label": item.column,
            "value": item.column,
            "quality":item.density==100?"Excellent":item.density>97?"Good":"Poor",
            "data_type":'daily',
            "type" : ColumnData.find(x=>x.column == item.column)?.type || "other",
            ...item
          }
        })
        setDailyStats(tempdata)
        setloading(false)
      }).catch(err=>{
        console.log(err);
        message.error(err?.response?.data?.error, 5)
        setloading(false)
      })
    }


    useEffect(()=>{
      setDisableDates(null)
      if (props?.SelectedProvider?.value && props?.SelectedProviderDataset?.value){
        getStatusData()
        GetSkewnessKurtosisGraphData()
      }
    },[props?.SelectedProvider?.value,props?.SelectedProviderDataset?.value])
    

    return (
      ColumnData && ColumnData.length !== 0 ?
      <Box sx={{ p: 0 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
          <Box style={{color:'var(--textPrimary'}}>
            <Typography variant="h2" sx={{ mb: 0.5 }}>
              Data Quality
            </Typography>
            <Typography variant="body1">
              Comprehensive dataset health assessment
            </Typography>
          </Box>
        </Box>
        

        {/* Enhanced Data Quality Table */}
        <Paper>
          <Box sx={{ p: 2, borderBottom: '1px solid #334155' }}>
            <Typography variant="h3" style={{fontWeight:600}}>
              Column Data Quality Summary
            </Typography>
          </Box>
          <DataGrid 
              rows={ColumnData}
              columns={TableColumns}
              initialState={{
              pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[10]}
              disableRowSelectionOnClick
            />
        </Paper>

        <Paper style={{marginTop:'25px'}}>
          <Box sx={{ p: 2, borderBottom: '1px solid #334155' }}>
            <span style={{fontSize:'16px', paddingRight:'10px'}} >Select Date to See Daily Data Quality</span>
            <DatePicker
              style={{
                  marginBottom:'30px',
                  color:'var(--textPrimary)'
                }}
              defaultPickerValue={SelectedDate}
              defaultValue={SelectedDate}
              onChange={(v)=>{
                if (!v) return; // handles clear
                setSelectedDate(v)
                GetDailyStats( v.format("YYYY-MM-DD"))
              }}
              disabledDate={(current) => {
                // Disable dates before minDate OR after maxDate
                return (
                  current && DisableDates &&
                  (current < DisableDates?.min_date.startOf("day") || current > DisableDates?.max_date.endOf("day"))
                );
              }}
            />
            <DataGrid
              columns={TableColumns.filter(item => !['kurtosis','skewness'].includes(item.field))}
              rows={DailyStats?DailyStats:[]}
              loading={loading}
              slots={{
                noRowsOverlay: () => (
                  <div style={{ padding: 20, textAlign: "center", color: "#888" }}>
                    No Data Available for selected Date. Please Change the date to see daily Data Quality
                  </div>
                )
              }}
              initialState={{
              pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[10]}
              disableRowSelectionOnClick
            />

          </Box>
        </Paper>


        <Modal 
          open={ShowPopUpGraph} 
          onClose={()=>{setShowPopUpGraph(false);setSkewKurtGraphData(null)}} 
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          >
          <Box 
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '60%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}
          >

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography id="modal-modal-title" variant="h4" component="h2">
                Skewness and Kurtosis Analysis - {SelectedColumn}
              </Typography>
              <Button variant="outlined" onClick={()=>setShowPopUpGraph(false)}>Close</Button>
            </Box>
            {GraphType=="outliers" ?
            <OutlierGraph chartData={OutliersGraphData} loading={loadingGraph} />:
            <SkewnessKurtosisGraph column={SelectedColumn} histogramData={SkewKurtGraphData} loading={loadingGraph} />
            }
          </Box>
        </Modal> 
        
      </Box>:
      <Box sx={{ p: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography variant="h4" color="textSecondary">
          Loading...
        </Typography>
      </Box>
    );
};

export default DataQuality;